const getters = {
  name: state => state.user.name,
  routes: state => state.user.routes,
  docRoutes: state => state.user.docRoutes,
  ntcRole: state => state.user.ntcRole,
  roleLoaded: state => state.user.roleLoaded,
  state: state => state
}
export default getters
